import { render, staticRenderFns } from "./renegociacao_editar.vue?vue&type=template&id=2f68120d"
import script from "./renegociacao_editar.vue?vue&type=script&lang=js"
export * from "./renegociacao_editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports